import { Component, OnInit } from '@angular/core';
import { ShoppingCartService } from '../services/shopping-cart.service';

@Component({
  selector: 'app-shoping-cart',
  templateUrl: './shoping-cart.component.html',
  styleUrls: ['./shoping-cart.component.css']
})
export class ShopingCartComponent implements OnInit {

  cart$;
  constructor(private shoppingCartService:ShoppingCartService) { }

  async ngOnInit() {
    this.cart$ = await this.shoppingCartService.getCart();
  }
  clearCart(){
    this.shoppingCartService.clearCart();
  }
}



// WEBPACK FOOTER //
// G:/MyProjects/Angular/oshop/src/app/shoping-cart/shoping-cart.component.ts